import { initModule } from './init-module';

initModule();

// Routes
export { AssessmentRoutes } from './assessment.routes';
